import {UT_SUCCESS} from '../get-templates/constants'
import {updateAudit as updateTemplateAPI} from '../../../services/audits'

export async function updateTemplate(id, data = null, dispatch) {
  try {
    let response = await updateTemplateAPI(id, data)
    dispatch({type: UT_SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Update Template Failed: ${data.name}`)
    return e.response
  }
}
